if (!customElements.get('smaxup-storefront-preview')) {
  customElements.define('smaxup-storefront-preview', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.on = (el, type, fn, extra = {}) => el?.addEventListener(type, fn, { signal: this.abort.signal, ...extra });
      this.dialog = this.querySelector('[data-email-dialog]');
      this.bar = this.querySelector('[data-sticky-purchase]');
      this.spacer = this.querySelector('[data-sticky-spacer]');
      this.product = document.querySelector('[data-smaxup-ui-preview]');
      this.initializeSticky(); this.initializeEmail();
    }
    initializeSticky() {
      if (!this.bar || !this.product || this.dataset.productPage !== 'true') return;
      this.bundle = this.querySelector('[data-sticky-bundle]');
      this.quantity = this.querySelector('[data-sticky-quantity]');
      this.submit = this.querySelector('[data-sticky-submit]');
      this.on(this.bundle, 'change', () => {
        const input = this.panel?.querySelector('[data-smaxup-preview-variant][value="' + this.bundle.value + '"]');
        if (!input || input.disabled) return;
        input.checked = true;
        if (this.panel.smaxupSyncSelectedVariant) this.panel.smaxupSyncSelectedVariant();
        else input.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncSticky();
      });
      this.on(this.quantity, 'change', () => {
        const input = this.panel?.querySelector('[data-smaxup-quantity-input]');
        if (!input || !this.quantity.reportValidity()) return;
        input.value = this.quantity.value; input.dispatchEvent(new Event('change', { bubbles: true })); this.syncSticky();
      });
      this.on(this.submit, 'click', () => {
        if (!this.quantity.reportValidity()) return;
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        const main = this.panel?.querySelector('[data-smaxup-preview-submit]');
        const form = main?.form;
        const status = this.querySelector('[data-sticky-status]');
        if (!main || !form || main.disabled) {
          if (status) status.textContent = 'This selection is not available right now.';
          return;
        }
        if (status) status.textContent = 'Adding to cart…';
        this.submit.disabled = true;
        this.submit.setAttribute('aria-busy', 'true');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(main);
        else main.click();
      });
      this.on(window, 'scroll', () => this.queueSync(), { passive: true });
      this.on(window, 'resize', () => this.queueSync());
      this.on(this.product, 'input', () => this.queueSync());
      this.on(this.product, 'change', () => this.queueSync());
      this.productObserver = new MutationObserver(() => this.queueSync());
      this.productObserver.observe(this.product, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden','disabled','aria-busy'] });
      this.overlayObserver = new MutationObserver(() => this.queueSync());
      this.overlayObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(() => this.queueSync());
      this.resizeObserver.observe(this.product); this.resizeObserver.observe(this.bar);
      this.syncSticky();
    }
    queueSync() {
      if (this.syncFrame) return;
      this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.syncSticky(); });
    }
    syncSticky() {
      if (!this.bar || !this.product) return;
      this.panel = [...this.product.querySelectorAll('[data-smaxup-model-panel]')].find(panel => !panel.hidden);
      const main = this.panel?.querySelector('[data-smaxup-preview-submit]');
      const qty = this.panel?.querySelector('[data-smaxup-quantity-input]');
      if (!main || !qty) { this.bar.hidden = true; this.spacer.style.height = '0px'; return; }
      const variants = [...this.panel.querySelectorAll('[data-smaxup-preview-variant]')];
      const selected = variants.find(input => input.checked);
      const signature = variants.map(input => input.value + ':' + input.disabled).join('|');
      if (signature !== this.variantSignature) {
        this.bundle.replaceChildren(...variants.map(input => {
          const option = document.createElement('option'); option.value = input.value;
          option.textContent = input.dataset.bundleLabel || input.value; option.disabled = input.disabled; return option;
        }));
        this.variantSignature = signature;
      }
      if (selected) this.bundle.value = selected.value;
      this.querySelector('[data-sticky-title]').textContent = this.panel.querySelector('h1')?.textContent.trim() || 'SMAXUP';
      for (const attr of ['min','max','step']) {
        if (qty.hasAttribute(attr)) this.quantity.setAttribute(attr, qty.getAttribute(attr)); else this.quantity.removeAttribute(attr);
      }
      if (document.activeElement !== this.quantity) this.quantity.value = qty.value;
      this.querySelector('[data-sticky-selection]').textContent = this.panel.querySelector('[data-smaxup-preview-selected]')?.textContent.trim() || '';
      this.querySelector('[data-sticky-total]').textContent = this.panel.querySelector('[data-smaxup-preview-total]')?.textContent.trim() || '';
      this.submit.disabled = main.disabled; this.submit.textContent = main.textContent.trim();
      const header = document.querySelector('.smaxup-site-header--sticky');
      const threshold = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const passed = main.getBoundingClientRect().bottom <= threshold && main.getClientRects().length > 0;
      const overlay = this.dialog?.open || document.documentElement.classList.contains('smaxup-cart-drawer-open');
      this.bar.hidden = !passed || !!overlay;
      this.spacer.style.height = this.bar.hidden ? '0px' : this.bar.getBoundingClientRect().height + 'px';
    }
    initializeEmail() {
      if (!this.dialog) return;
      const key = 'smaxup-d044-email-visit';
      const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch { /* Session remains usable when storage is unavailable. */ } };
      const close = () => { remember(); this.dialog.close(); };
      this.querySelectorAll('[data-email-close]').forEach(control => this.on(control, 'click', close));
      this.on(this.dialog, 'cancel', remember);
      this.on(this.dialog, 'close', () => { document.documentElement.classList.remove('smaxup-email-open'); this.queueSync(); });
      const emailForms = [...this.querySelectorAll('[data-email-form]')];
      emailForms.forEach(form => {
        this.on(form, 'submit', () => {
          if (!form.checkValidity()) return;
          form.setAttribute('aria-busy', 'true');
          const submit = form.querySelector('[data-email-submit]');
          if (submit) submit.disabled = true;
        });
      });
      const forced = new URLSearchParams(location.search).get('smaxup_email_preview') === '1';
      const feedback = this.querySelector('[data-email-success], [data-email-error]');
      if (feedback) {
        if (feedback.hasAttribute('data-email-success')) remember();
        if (this.dialog && !this.dialog.open) {
          this.dialog.showModal();
          document.documentElement.classList.add('smaxup-email-open');
          this.queueSync();
        }
        feedback.focus?.();
        return;
      }
      let seen = false;
      try { const timestamp = Number(localStorage.getItem(key)); seen = timestamp > 0 && Date.now() - timestamp < (Number(this.dataset.dismissDays) || 30) * 86400000; } catch { /* Show once on this page. */ }
      if ((seen || this.dataset.knownSubscriber === 'true') && !forced) return;
      if (window.Shopify?.designMode && this.dataset.editorPopup !== 'true') return;
      this.openEmail = () => {
        if (!this.isConnected || this.dialog.open) return;
        if (document.hidden || document.querySelector('dialog[open]') || document.documentElement.classList.contains('smaxup-cart-drawer-open')) {
          this.timer = setTimeout(this.openEmail, 1000); return;
        }
        this.dialog.showModal(); document.documentElement.classList.add('smaxup-email-open'); remember(); this.queueSync();
      };
      if (forced) {
        this.timer = setTimeout(this.openEmail, 1000);
        return;
      }
      let delayPassed = false;
      let engaged = false;
      const tryOpen = () => { if (delayPassed && engaged) this.openEmail(); };
      const markEngaged = () => { engaged = true; tryOpen(); };
      const onScroll = () => {
        const page = document.documentElement;
        if ((window.scrollY + window.innerHeight) / Math.max(page.scrollHeight, 1) >= 0.5) markEngaged();
      };
      this.on(window, 'scroll', onScroll, { passive: true });
      this.on(document, 'mouseout', event => {
        if (!event.relatedTarget && event.clientY <= 0) markEngaged();
      });
      this.timer = setTimeout(() => { delayPassed = true; tryOpen(); }, (Number(this.dataset.popupDelay) || 8) * 1000);
      onScroll();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.productObserver?.disconnect(); this.overlayObserver?.disconnect(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.syncFrame); clearTimeout(this.timer);
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('smaxup-email-open'); }
    }
  });
}
